module.exports = __webpack_public_path__ + "static/03-dece3b7a4b6d086524732d6219905824.jpeg";